/* Website enquiry submission — posts to the VPS enquiry endpoint.
   The endpoint is fire-and-forward and stores no personal data; it only emails
   the enquiry to contact@didiers.co.uk. Same-origin in production (Caddy proxies
   /api/* to the FastAPI container), so no CORS config is needed. */

const API_BASE = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/+$/, '');

export type EnquiryType = 'general' | 'innovation' | 'career' | 'sample';

export interface EnquiryPayload {
  type: EnquiryType;
  name: string;
  email: string;
  phone?: string;
  message?: string;
  /** Innovation: the product name/description for context. */
  product?: string;
  /** Careers: CV attachment (streamed into the email, never stored). */
  cv?: File | null;
}

export class EnquiryError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function sendEnquiry(p: EnquiryPayload): Promise<void> {
  const fd = new FormData();
  fd.set('enquiry_type', p.type);
  fd.set('name', p.name);
  fd.set('email', p.email);
  if (p.phone) fd.set('phone', p.phone);
  if (p.message) fd.set('message', p.message);
  if (p.product) fd.set('product', p.product);
  if (p.cv) fd.set('cv', p.cv);

  let res: Response;
  try {
    res = await fetch(`${API_BASE}/api/enquiry`, { method: 'POST', body: fd });
  } catch {
    throw new EnquiryError('Network error — please check your connection and try again.', 0);
  }
  if (!res.ok) {
    let detail = 'Something went wrong. Please try again.';
    try {
      const j = await res.json();
      if (j?.detail) detail = String(j.detail);
    } catch {
      /* keep default */
    }
    throw new EnquiryError(detail, res.status);
  }
}
